<template>
  <div>
    <AppPopup
      :discount-id="configData.DiscountId"
      :title="configData.Title"
      :sub-title="configData.SubTitle"
      :image-url="configData.ImageUrl"
      :display-order="configData.DisplayOrder"
      :popup-price-monthly="configData.PopupPriceMonthly"
      :popup-price="configData.PopupPrice"
      :short-description="configData.ShortDescription"
      :usp-items="configData.UspItems"
      :charging-info="configData.ChargingInfo"
    />
  </div>
</template>

<script lang="ts" setup>
import type { AggregatedPopupPriceDto } from '~/models/ListingProduct.api.model';

interface Props {
  configData: {
    DiscountId: number;
    Title: string;
    SubTitle: string;
    ImageUrl: string;
    DisplayOrder?: number;
    PopupPriceMonthly: number;
    PopupPrice: { [key: number]: AggregatedPopupPriceDto };
    ShortDescription: string;
    UspItems?: { label: string; subLabel?: string }[];
    ChargingInfo?: {
      chargerIncluded: boolean;
      wiredChargerMinWatts: string;
      wiredChargerMaxWatts: string;
      usbPdSupported?: boolean;
    };
  };
}

defineProps<Props>();
</script>
<style scoped lang="scss"></style>
